<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 310 310" style="enable-background:new 0 0 310 310;" xml:space="preserve">
        <g id="XMLID_826_">
            <path id="XMLID_827_" class="twitter" d="M303,57.4c-4.9,2.2-9.9,4-15,5.5c6.1-6.8,10.7-14.9,13.5-23.7c0.6-2,0-4.1-1.6-5.4
        c-1.6-1.3-3.9-1.4-5.7-0.4c-10.9,6.4-22.6,11.1-34.9,13.8c-12.4-12.1-29.2-19-46.6-19c-36.7,0-66.5,29.9-66.5,66.5
        c0,2.9,0.2,5.8,0.5,8.6c-45.5-4-87.9-26.4-116.9-62c-1-1.3-2.6-2-4.3-1.8c-1.6,0.1-3.1,1-3.9,2.5c-5.9,10.1-9,21.7-9,33.5
        c0,16,5.7,31.2,15.8,43.1c-3.1-1.1-6.1-2.4-8.9-4c-1.5-0.9-3.4-0.8-4.9,0c-1.5,0.9-2.5,2.5-2.5,4.2c0,0.3,0,0.6,0,0.9
        c0,23.9,12.9,45.5,32.6,57.2c-1.7-0.2-3.4-0.4-5.1-0.7c-1.7-0.3-3.5,0.3-4.7,1.6c-1.2,1.3-1.6,3.2-1,4.8
        c7.3,22.8,26.1,39.5,48.7,44.6c-18.8,11.8-40.3,18-62.9,18c-4.7,0-9.5-0.3-14.1-0.8c-2.3-0.3-4.5,1.1-5.3,3.3c-0.8,2.2,0,4.6,2,5.9
        c29,18.6,62.6,28.4,97,28.4c67.8,0,110.1-31.9,133.8-58.8c29.5-33.4,46.4-77.7,46.4-121.4c0-1.8,0-3.7-0.1-5.5
        c11.6-8.8,21.6-19.4,29.8-31.5c1.2-1.8,1.1-4.3-0.3-6C307.4,57,305,56.5,303,57.4z" />
        </g>
    </svg>
</template>
<style type="text/css">
.dark .twitter {
    fill: #FCEA0D;
}
.twitter {
    fill: #069AEF;
}

</style>
